import { artConfigBuildings } from "../../assetBundles/artConfigBuildings";
import { IdOrientation } from "../../constants/IdOrientation";
import { BF2CreateAsset, BF2PositionSurroundingCorner } from "../BF2BuildingGraphicsUtils";
export var GetDirtCornerIso = function (data, orientation, baseSetup) {
    var config = artConfigBuildings["dirtCorner_" + orientation];
    var sprite = BF2CreateAsset(config.assets[0], false);
    sprite.name = "Dirt Corner [" + orientation + "]";
    BF2PositionSurroundingCorner(sprite, orientation, baseSetup);
    if (orientation === IdOrientation.Up) {
        sprite.scale.y *= -1;
    }
    return sprite;
};



//////////////////
// WEBPACK FOOTER
// ./src/graphics/fence/GetDirtCornerIso.ts
// module id = 2212
// module chunks = 3